<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader, Multiselect
  },
  data() {

    return {
      title: "Produtos (Estoque Endereço)",
      items: [
        {
          text: "Estoque",
          href: "/"
        },
        {
          text: "Produtos (Estoque Endereço)",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,

      empresaData: null,

      wmsEnderecoSel: null,
      showModalWmsEndereco: false,
      dtListPesqWmsEndereco: null,

      dtlistPesqOrctoItem: null,

      showModalEndereco: false,
      wmsTransfData: {},
      wmsTransfDataSaldo: {},
      wmsTransfDataLote: null,
      wmsTransfDataDtvalid: null,
      prodSaldoDispData: {},
      msgValidacaoTrans: null,
      loteList: [],
      endList: [],
      loteSelected: null,
      endSelected: null,
      selectedAtivo: false,
      submitted: false,

      tipoTransferencia: 'N',
    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    },

    getSelectedSaldo() {
      const selectedItem = this.endList.find(item => item.id === this.endSelected);
      return selectedItem ? selectedItem.saldo : '';
    },

    getSelecteDtValid() {
      const selectedItem = this.endList.find(item => item.id === this.endSelected);
      return selectedItem ? selectedItem.dtvalid : '';
    },

    getSelectedendAtu() {
      const selectedItem = this.endList.find(item => item.id === this.endSelected);
      return selectedItem ? selectedItem.endereco : 'Sem Endereço';
    },


  },

  mounted() {
    console.log('mounted produto-list-endereco_0')
    this.atualizaDataList()
  },

  methods: {

    abrirEstoque3d(){
      console.log('abrirEstoque3d')
      window.open('https://macrolub.ddns.net/estoquetresd', 'targetWindow',`toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=SomeSize, height=SomeSize`);
    },

    pesqProduto(evt) {
      console.log('pesqOrctoItem_0')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.dtlistPesqOrctoItem = null
        this.loadingOrctoItem = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // console.log(res.data.length)
          this.dtlistPesqOrctoItem = res.data

        })
      }
    },

    pesqWmsEndereco(evt) {
      console.log('pesqWmsEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        //this.orctoData.condpgto = ''
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "produtoslote", origem_id: null }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqWmsEndereco = res.data
        })
      }
    },

    escolheuWmsEndereco() {
      console.log('escolheuWmsEndereco')
      this.loadingWmsEndereco = true
      console.log(this.wmsEnderecoSel)
      this.showModalWmsEndereco = false

      this.title = `(${this.totalList}) Produtos (Estoque Endereço): ${this.wmsEnderecoSel}`
      this.atualizaDataList()
    },

    escolheuProduto() {
      console.log('escolheuItem')
      this.loadingOrctoItem = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.wmsTransfData.produto }
      }).then((res) => {
        console.log('then axios_escolheu_ped_item')
        console.log(res.data)

        this.wmsTransfData = {
          orcamento_id: this.idData,
          produto_id: res.data[0]['id'],
          produto: res.data[0]['codigo'],
          descprod: res.data[0]['descricao'],
          und: res.data[0]['unidade'],
          vlrunitliq: res.data[0]['preco'],
          vlrunitbrt: res.data[0]['preco'],
          vlrtotalliq: res.data[0]['preco'],
          vlrtotalbrt: res.data[0]['preco'],
          saldo: res.data[0]['saldo'],
          pesobrtun: res.data[0]['pesobrt'],
          pesobrttot: res.data[0]['pesobrt'],
          pesoliqun: res.data[0]['pesoliq'],
          pesoliqtot: res.data[0]['pesoliq'],
          cubunt: res.data[0]['compr'] * res.data[0]['larg'] * res.data[0]['altu'],
          cubtot: res.data[0]['compr'] * res.data[0]['larg'] * res.data[0]['altu'],

          qtd: 1
        }

        console.log(`orctoItemData: ${this.orctoItemData}`)
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingOrctoItem = false
      })
    },

    confirmarAssocRomaNovo(){
      console.log('confirmarAssocRomaNovo')
      // console.log(this.wmsosList)
      const idsAtualizar = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      this.updating = true
      api.post(`${getBaseUrl()}api/wmsromawmsosnv`, {
        idsData: idsAtualizar
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.showAssocRoma = false
        this.updating = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data[0].id)
          window.open(routeData.href, '_blank')
        })
      })
    },

    pesqRomaneio(evt){
      console.log('pesqRomaneio')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/wmsromapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRoma = res.data
        });
      }
    },

    carregouGrid(e){
      console.log('carregouGrid')
      this.totalList = e.component.totalCount()
      this.title = `(${this.totalList}) Produtos (Estoque Endereço): ${this.wmsEnderecoSel === null ? 'SELECIONAR ENDEREÇO' : this.wmsEnderecoSel}`
    },

    atualizaDataList(){
      console.log('atualizaDataList_prodEst')
      // console.log(this.wmsEnderecoSel)

        const ender = this.wmsEnderecoSel
        this.dataList = new CustomStore({
          key: "produto_id",
          load: function(loadOptions){
            let queryArray = []
            if (loadOptions['filter']) {
              if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
                loadOptions['filter'].forEach((value) => {
                  // console.log('value_filter')
                  // console.log(value)
                  // console.log(value[0])
                  // console.log(typeof (value))
                  if (typeof (value) === "object") {
                    queryArray.push({
                      cmp: value[0],
                      opr: value[1],
                      val: value[2],
                    })
                  }
                })
              } else {
                queryArray.push({
                  cmp: loadOptions['filter'][0],
                  opr: loadOptions['filter'][1],
                  val: loadOptions['filter'][2],
                })
              }
            }
            const paramsReq = {
              'skip': loadOptions['skip'],
              'take': loadOptions['take'],
              'filter': queryArray,
              'sort': loadOptions['sort'],
              'ender': ender

            }
            console.log('paramsReq')
            console.log(paramsReq)
            return api.get(`${getBaseUrl()}api/prodestender`, {
              params: paramsReq
            }).then(response => {
              console.log('response.data_0')
              console.log(response)
              return {
                data: response.data[0],
                totalCount: response.data[1],
              }
            })
          },
        })
    },

    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },

    novoProduto(){
      console.log('novoProduto')
      this.$router.push(`/produto/editar/0`)
    },

    informouProduto() {
      console.log('informouProduto')
      this.loadingOrctoItem = true
      console.log(this.wmsTransfData.produto)

      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.wmsTransfData.produto }
      }).then((res) => {
        console.log('then axios');
        console.log(res.data);

        this.wmsTransfData.descprod = res.data[0].descricao;
        this.wmsTransfDataSaldo = res.data[3];
        this.wmsTransfDataLote = this.wmsTransfDataSaldo[0].lote;
        this.wmsTransfDataDtvalid = this.wmsTransfDataSaldo[0].dtvalid;
        this.loteList = res.data[4];

        this.selectedAtivo = true;

        if(this.loteSelected === null){
          this.loteSelected = this.loteList[0].lote;
        }

      }).then(() =>{
        // this.$refs.lote.focus()
        this.informouLote()
      })
    },

    informouLote(){
      console.log('informouLote')

      const data = this.wmsTransfDataSaldo
      const endList = [];

      data.forEach((item) => {
        if (this.loteSelected === item.lote){
          endList.push({
            id: item.id,
            lote: item.lote,
            dtvalid: item.dtvalid,
            endereco: item.endwms,
            saldo: item.saldo,
          })
        }
      })

      this.endList = endList;

      if(this.endSelected === null){
        this.endSelected = this.endList[0].id;
      }

      /*setTimeout(()=>{
        this.$refs.dtvalid.focus()
      }, 500)*/
    },

    informouQtdTransf(){

      if(this.tipoTransferencia === "N"){
        if(!this.wmsTransfData.novoendwms || !this.getSelectedSaldo || this.getSelectedSaldo < this.wmsTransfData.qtdtransf){
          console.log('informouQtdTransf')
          Swal.fire({
            position: "top-center",
            icon: "error",
            title: "Erro, favor verificar dados de transferência!",
            showConfirmButton: false,
            timer: 1800
          })
        } else{
          console.log('informouQtdTransf')
          this.confirmarTransf()
        }

      } else if(this.tipoTransferencia === "B") {
        console.log('informouQtdTransf')
        this.confirmarTransf()
      }

      setTimeout(() => {
        this.$refs.qtdtransf.focus()
      }, 500)
    },

    informouNovoPalete(){
      console.log('informouNovoPalete')

      api.get(`${getBaseUrl()}api/wmspalcod`, {
        params: {coddata: this.wmsTransfData.novopalete}
      }).then((res) => {
        console.log('then axios endwms')
        console.log(res.data)
        if (res.data[0]){
          this.wmsTransfData.novoendwms = res.data[0]['endereco']

          this.confirmarTransf()

        }
      })

      this.$refs.novopalete.focus()
    },

    informouNovoEndereco(){
      console.log('informouNovoEndereco')

      this.loadingWmsEndereco = true
      console.log(this.wmsTransfData.novoendwms)
      this.showModalWmsEndereco = false

      this.title = `(${this.totalList}) Produtos (Estoque Endereço): ${this.wmsTransfData.novoendwms}`

      setTimeout(()=>{
        this.$refs.qtdtransf.focus()
      },500)
    },

    informouDtValid(){
      console.log('informouDtValid')

      api.post(`${getBaseUrl()}api/prodtransf`, {
        wmsTransfData: this.wmsTransfData
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data.endwms)
        if (res.data[0]){
          this.prodSaldoDispData = res.data[0]
          this.wmsTransfData.qtdtransf = res.data[0].saldo
        } else {
          this.prodSaldoDispData = {}
          this.wmsTransfData.qtdtransf = 0
        }
      }).then(() => {
        this.$refs.endwms.focus()
      }).catch((e) => {
        console.log('error')
        console.log(e)
      })
    },

    confirmarTransf(){
      console.log('confirmarTransf')
      this.submitted = true

      if(this.tipoTransferencia === "N"){
        this.titleswal = "Confirmação de Transferência"
      } else if(this.tipoTransferencia === "B"){
        this.titleswal = "Confirmação de Balanço"
        this.wmsTransfData.novoendwms = this.getSelectedendAtu;
      }

      Swal.fire({
        position: "center",
        icon: "question",
        title: this.titleswal,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          const selectedItem = this.endList.find(item => item.id === this.endSelected);

          this.wmsTransfData.idestoque = selectedItem.id;

          this.updating = true
          api.post(`${getBaseUrl()}api/prodtransfconf`, {
            wmsTransfData: this.wmsTransfData,
            tipoTransfer: this.tipoTransferencia
          }).then((res) => {

            console.log('then axios')
            console.log(res.data)

            if (res.data.success)  {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Transferência concluída com sucesso!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.atualizaDataList()
              })
            }else{
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 3000
              })
            }

            this.prodSaldoDispData = {}
            this.wmsTransfData = {}
            this.submitted = false
            this.$refs.produto.focus()
            this.msgValidacaoTrans = null
            this.endSelected = null
            this.loteSelected = null
            this.tipoTransferencia = 'N'
            this.showModalEndereco = false;
            this.updating = false
          })
        }
      })
    },

    alterarEndereco(){
      console.log('alterarEndereco')
      this.showModalEndereco = true

    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      const routeData = this.$router.resolve(`/produto/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'TRA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = 'rgba(0,0,0,0.38)'
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {

      switch (e.value) {

        case 'EL':
          return 'Elaboração(EL)'

        case 'PR':                   // desativado
          return 'Ordem Saída (PR)'  // desativado

        case 'OS':
          return 'Ordem Saída (OS)'

        case 'CF':
          return 'Pedido Conferido (CF)'
        case 'NEM':
          return 'Nota Fiscal Emitida (NEM)'
        case 'NLO':
          return 'Não Encontrado (NLO)'
        case 'ENP':
          return 'Entregue no Prazo (ENP)'
        case 'ECR':
          return 'Entregue com Ressalva (ECR)'
        case 'EAT':
          return 'Entregue com Atraso (EAT)'
        case 'CCT':
          return 'Com CTe (CCT)'
        case 'TRA':
          return 'Transferido (TRA)'
        case 'CAN':
          return 'Cancelado (CAN)'


        case 'SCT':
          return 'Sem CTe'
        case 'NEP':
          return 'Dentro do Prazo (Não Entregue)'
        case 'NEF':
          return 'Fora do Prazo (Não Entregue)'
      }

      return e.value
    },



    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    }

  },


};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalWmsEndereco = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Novo Produto"
              text="Novo Produto"
              :on-click="novoProduto"/>


        </DxItem>

        <!--<DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Transferencia"
              text="Transferencia"
              :on-click="alterarEndereco"/>
        </DxItem>-->



        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="box"
              hint="Estoque 3D"
              text="Estoque 3D"
              :on-click="abrirEstoque3d"/>
        </DxItem>


      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strProdutoEstoqEnderList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />


        <DxColumn sort-order="desc"
                  data-field="produto_id"
                  caption="ID"
                  alignment="left"
                  data-type="number"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="empresa_nome" caption="Empresa" alignment="left" data-type="text"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="false" />

        <DxColumn data-field="empresa_cnpj" caption="Empresa CNPJ" alignment="left" data-type="text"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="false" />

        <DxColumn data-field="produto_codigo"
                  caption="Código"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>

        <DxColumn data-field="produtosaldoloc_endwms"
                  caption="Endereço"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>


        <DxColumn data-field="produto_descricao"
                  caption="Descrição"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>

        <DxColumn data-field="produto_unidade"
                  caption="Unidade"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>

        <DxColumn data-field="produtosaldoloc_palete"
                  caption="Palete"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>


        <DxColumn data-field="produtosaldoloc_lote"
                  caption="Lote"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>


        <DxColumn
            data-field="produtosaldoloc_dtvalid"
            caption="Validade"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="produtosaldoloc_saldo"
            caption="Saldo"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true" />


        <DxColumn
            data-field="produtosaldoloc_wmsos_id"
            caption="OS associado"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true" />



        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>




    <b-modal title="Detalhes Endereço (WMS)" v-model="showModalWmsEndereco" centered hide-footer>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Endereço</span>

          <multiselect id="formapgto"
                       @search-change="pesqWmsEndereco"
                       @select="escolheuWmsEndereco"
                       v-model="wmsEnderecoSel"
                       placeholder="Pesquisar forma de pagamento"
                       :options="dtListPesqWmsEndereco"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="descricao">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <div v-if="wmsEnderecoSel">


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalWmsEndereco = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
<!--          -->
        </div>
      </div>

    </b-modal>

    <b-modal size="lg"
             title="Transferência de Produto"
             v-model="showModalEndereco" centered hide-footer>

      <div class="col-md-12">

        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label for="produtoitem">Favor informar o produto</label>
              <multiselect id="produtoitem" ref="focusThis" @search-change="pesqProduto" @select="informouProduto"
                       v-model="wmsTransfData.produto" placeholder="Pesquisar produto" :options="dtlistPesqOrctoItem"
                       :searchable="true" label="descricao" class="multiselect-size" track-by="descrcodigo" value-prop="codigo">

                <template #option="slotProps" v-if="dtlistPesqOrctoItem">
                  <div class="row" style="min-width: 100%;">

                    <div style="min-width: 100%;">
                      <span class="text-info">
                        {{ slotProps.option.codigo }}
                      </span>
                      <span class="mx-4">
                        {{ slotProps.option.unidade }}
                      </span>
                    </div>

                    <div class="col-12">
                      <span class="mt-5 font-size-15">
                        {{ slotProps.option.descricao }}
                      </span>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>

          <div class="col-sm-5">
            <div class="float-end" style="width: 120px;">
              <h5 class="font-size-14 mt-2" >Transfêrencia</h5>
              <div class="d-flex align-items-center justify-content-between" style="margin-top: -13px">
                <b-form-checkbox
                    switch
                    size="lg"
                    value="B"
                    unchecked-value="N"
                    disabled
                    v-model="tipoTransferencia">
                  {{ tipoTransferencia === 'N' ? 'Normal' : 'Balanço' }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label for="produto">Código do produto</label>
              <input
                  id="produto"
                  style="height: 40px"
                  ref="produto"
                  v-model="wmsTransfData.produto"
                  type="text"
                  class="form-control"
                  @keypress.enter="informouProduto"
                  placeholder="Enter para confirmar..."/>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <label for="produtodesc">Produto</label>
              <input
                  id="produtodesc"
                  style="height: 40px"
                  ref="produtodesc"
                  v-model="wmsTransfData.descprod"
                  type="text"
                  class="form-control"
                  :disabled="true"
                  placeholder="Produto"/>
            </div>
          </div>
        </div>

        <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="lote">Lote</label>
                <div v-if="selectedAtivo === false" class="position-relative">
                  <input
                      id="lote"
                      style="height: 40px"
                      ref="lote"
                      type="text"
                      :disabled="true"
                      @keypress.enter="informouLote"
                      class="form-control"
                      placeholder="Lote de fabricação"/>
                </div>
                <div v-else class="position-relative">
                  <b-form-select id="lote" ref="lote" v-model="loteSelected" @click="informouLote">
                    <b-form-select-option v-for="lot in loteList" :value="lot.lote" :key="lot.id" @click="informouLote(lot.lote)">
                      {{ lot.lote ? lot.lote : "Sem Lote"  }}
                    </b-form-select-option>
                  </b-form-select>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="dtvalid">Data de validade</label>
                <input
                    id="dtvalid"
                    style="height: 40px"
                    ref="dtvalid"
                    :value="getSelecteDtValid"
                    type="date"
                    :disabled="true"
                    @keypress.enter="informouDtValid"
                    class="form-control"
                    placeholder="Data de validade"/>
              </div>
            </div>
          </div>

        <div class="row">
            <div class="col-sm-6">
              <div class="mb-3">
                <label for="endwms">Endereço Atual</label>
                <div v-if="selectedAtivo === false" class="position-relative">
                  <input
                      id="endwms"
                      style="height: 40px"
                      ref="endwms"
                      type="number"
                      :disabled="true"
                      class="form-control"
                      placeholder="Endereço Atual"/>
                </div>

                <div v-else class="position-relative">
                  <b-form-select id="endwms" ref="endwms" v-model="endSelected">
                    <b-form-select-option v-for="end in endList" :value="end.id" :key="end.id">
                      {{ end.endereco ? end.endereco : "Sem Endereço" }}
                    </b-form-select-option>
                  </b-form-select>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="qtddisp">Quantidade Disponível</label>
                <input
                    id="qtddisp"
                    style="height: 40px"
                    ref="qtddisp"
                    type="number"
                    :value="getSelectedSaldo"
                    :disabled="true"
                    class="form-control"
                    placeholder="Quantidade Disponível"/>
              </div>
            </div>
          </div>

        <div class="row">
          <div v-if="tipoTransferencia === 'N'" class="col-sm-6">
            <div class="mb-3">
              <label for="novoendwms">Novo Endereço</label>

              <multiselect id="novoendwms"
                           @search-change="pesqWmsEndereco"
                           @select="informouNovoEndereco"
                           v-model="wmsTransfData.novoendwms"
                           placeholder="Pesquisar endereços"
                           :options="dtListPesqWmsEndereco"
                           :searchable="true"
                           label="descricao"
                           ref="novoendwms"
                           track-by="descricao"
                           value-prop="descricao">
                <template #option="slotProps">
                  <div class="row">
                    <div>
                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                      <span class="mx-4" >
                              {{ slotProps.option.endereco }}
                            </span>
                    </div>
                    <div class="mt-2 ">{{ slotProps.option.descricao }}</div>
                    <span class="mx-4" >
                            </span>
                    <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                  </div>
                </template>
              </multiselect>

              <div v-if="submitted && !wmsTransfData.novoendwms">
                <span class="text-danger font-size-11">Campo endereço obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

          <div v-if="tipoTransferencia === 'N'" class="col-sm-6">
            <label for="qtdtransf">Quantidade a Transferir</label>
            <div class="position-relative">
              <input
                  id="qtdtransf"
                  style="height: 40px"
                  type="number"
                  ref="qtdtransf"
                  v-model="wmsTransfData.qtdtransf"
                  @keypress.enter="informouQtdTransf"
                  class="form-control"
                  placeholder="Quantidade a Transferir"/>
            </div>

            <div v-if="submitted && !wmsTransfData.qtdtransf">
              <span class="text-danger font-size-11">Campo endereço obrigatório, favor preencher.</span>
            </div>
          </div>

          <div v-if="tipoTransferencia === 'B'" class="col-md-6">
            <div class="mb-3">
              <label for="qtddisp">Endereço de Balanço</label>
              <input
                  id="endwnsbalance"
                  style="height: 40px"
                  ref="endwnsbalance"
                  type="text"
                  :value="getSelectedendAtu"
                  :disabled="true"
                  class="form-control"
                  placeholder="Sem Endereço"/>
            </div>
          </div>

          <div v-if="tipoTransferencia === 'B'" class="col-sm-6">
            <label for="qtdtransf">Quantidade de Balanço</label>
            <div class="position-relative">
              <input
                  id="qtdtransf"
                  style="height: 40px"
                  type="number"
                  ref="qtdtransf"
                  v-model="wmsTransfData.qtdtransf"
                  @keypress.enter="informouQtdTransf"
                  class="form-control"
                  placeholder="Quantidade a Transferir"/>
            </div>

            <div v-if="submitted && !wmsTransfData.qtdtransf">
              <span class="text-danger font-size-11">Campo endereço obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="row">

            <b-alert  show dismissible variant="danger"  v-if="msgValidacaoTrans">
              <i class="mdi mdi-alert me-2"></i>
              {{ msgValidacaoTrans }}
            </b-alert>

          </div>

        <div class="text-end mt-5">

            <b-button variant="light" @click="showModalEndereco = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button v-if="tipoTransferencia ==='N'"
                      :disabled="!wmsTransfData.novoendwms || !getSelectedSaldo || getSelectedSaldo < wmsTransfData.qtdtransf"
                      type="submit" variant="success" class="ms-1" @click="confirmarTransf()">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>

            <b-button v-if="tipoTransferencia ==='B'"
                      :disabled="!getSelectedSaldo || !wmsTransfData.qtdtransf"
                      type="submit" variant="success" class="ms-1" @click="confirmarTransf()">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>

          </div>
      </div>

    </b-modal>


  </Layout>
</template>